<template>
  <section>
    <div class="tabContentBx">
      <div class="tabContent">
        <div class="formInfo mgb">
          <v-form ref="formMenu">
            <dl class="infoCont" v-if="!isModify && parent && Object.keys(parent).length > 0">
              <dt class="formInfoTxt small">상위메뉴</dt>
              <dd class="formInfoArea">
                <v-col class="mgr" sm="3">
                  {{ parent.menuName }}
                </v-col>
              </dd>
            </dl>

            <dl class="infoCont" v-if="menu.menuCategory !== 'ADMIN' ">

              <dt class="formInfoTxt small">메뉴 이미지</dt>
              <dd class="formInfoArea">
                <v-col class="mgr">
                  <vue-dropzone
                      ref="menuImageDropzone"
                      id="dropzone"
                      :options="dropzoneOptions"
                      :useCustomSlot="true"
                      @vdropzone-complete="imageUploadCompleteSuccess"
                      @vdropzone-success="imageUploadSuccess"
                      @vdropzone-removed-file="imageRemove"
                  >
                    <div v-if="menu.menuImage">
                      <v-badge
                          bordered
                          dark
                          color="black"
                          icon="mdi-delete"
                          overlap
                          @click.native="imageRemove"
                      >
                        <img :src="`${endPoint}/menu/${menu.menuImage}`" />
                      </v-badge>
                    </div>
                    <div class="dropzone-custom-content" v-else>
                      <h3 class="dropzone-custom-title">대표 이미지</h3>
                      <div class="subtitle">Drag and drop or click to select a file from your computer</div>
                    </div>
                  </vue-dropzone>
                </v-col>

              </dd>
            </dl>
            <dl class="infoCont">

              <dt class="formInfoTxt small">메뉴 명</dt>
              <dd class="formInfoArea">
                <v-col class="mgr" sm="6">
                  <v-text-field v-model="menu.menuName" label="메뉴 명"
                                dense clearable required
                                maxlength="100"
                                :rules="[() => !!menu.menuName || '메뉴 명을 입력해주세요.']"/>
                </v-col>
              </dd>
            </dl>
            <dl class="infoCont" v-if="menu.menuCategory === 'ADMIN' ">

              <dt class="formInfoTxt small">메뉴 icon css</dt>
              <dd class="formInfoArea">
                <v-col class="mgr d-flex" sm="6">
                  <v-icon style="padding-right: 10px">{{menu.menuIcon}}</v-icon>
                  <v-text-field v-model="menu.menuIcon" label="메뉴 icon"
                                dense clearable required
                                maxlength="100"/>
                </v-col>
              </dd>
            </dl>

            <dl class="infoCont">
              <dt class="formInfoTxt small">사용여부</dt>
              <dd class="formInfoArea">
                <v-col class="mgr" sm="3">
                  <v-switch
                      v-model="menu.activated"
                      flat
                      color="primary"
                      :label="menu.activated ? '사용' : '사용 안함'"
                  ></v-switch>
                </v-col>
              </dd>
              <dt class="formInfoTxt small">접근제어</dt>
              <dd class="formInfoArea">
                <v-col class="mgr" sm="3">
                  <v-switch
                      v-model="menu.protected"
                      flat
                      color="primary"
                      :label="menu.protected ? '사용' : '사용 안함'"
                  ></v-switch>
                </v-col>
              </dd>
            </dl>
            <dl class="infoCont">
              <dt class="formInfoTxt small">메뉴 타입</dt>
              <dd class="formInfoArea">
                <v-col class="mgr d-flex" sm="3">
                  <v-checkbox v-model="menu.menuType" value="TYPE_BOARD" label="게시판"></v-checkbox>
                  <v-checkbox v-model="menu.menuType" value="TYPE_PAGE" label="페이지"></v-checkbox>
                  <v-checkbox v-model="menu.menuType" value="TYPE_LINK" label="URL"></v-checkbox>
                </v-col>
              </dd>
              <dt class="formInfoTxt small">메뉴 연결</dt>
              <dd class="formInfoArea">
                <v-col class="mgr" sm="3">
                  <v-autocomplete :items="boards" item-value="boardId" item-text="boardName"
                                  label="게시판을 선택해주세요."
                                  dense clearable flat
                                  outlined required
                                  v-model="menu.boardId"
                                  :rules="[rules.required]"
                                  v-if="menu.menuType && menu.menuType === 'TYPE_BOARD'"
                  />
                  <v-autocomplete :items="pages" item-value="pageId" item-text="title"
                                  label="페이지를 선택해주세요."
                                  dense clearable flat
                                  outlined required
                                  v-model="menu.pageId"
                                  :rules="[rules.required]"
                                  v-if="menu.menuType && menu.menuType === 'TYPE_PAGE'"
                  />
                  <v-text-field v-model="menu.url"
                                label="URL 을 입력해주세요."
                                dense clearable required
                                maxlength="255"
                                :rules="[() => !!menu.menuName || 'URL 을 입력해주세요.']"
                                v-if="menu.menuType && menu.menuType === 'TYPE_LINK'"/>
                </v-col>
              </dd>

            </dl>


          </v-form>

        </div>
      </div>
    </div>

    <div class="btnStyleBx">
      <div class="btnCommon justify-center">
        <v-btn class="vBtn" @click="saveMenu">
          <v-icon left>mdi mdi-playlist-plus</v-icon>
          {{ isModify ? "저장" : "추가" }}
        </v-btn>
        <v-btn class="vBtn" @click="resetMenu" v-if="isModify">
          <v-icon left>mdi mdi-close</v-icon>
          취소
        </v-btn>
        <v-btn class="vBtn" @click="deleteMenu" v-if="isModify">
          <v-icon left>mdi mdi-playlist-remove</v-icon>
          삭제
        </v-btn>
      </div>
    </div>
  </section>
</template>

<script>
import menuApi from "@/api/MenuApi";
import boardApi from "@/api/BoardApi";
import pageApi from "@/api/PageApi";

import _ from "lodash";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'


export default {
  name: "Detail",
  components: {
    vueDropzone: vue2Dropzone
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isModify: Boolean,
    parent: Object
  },
  data: () => ({
    rules: {
      required: value => !!value || '필수 입력 항목입니다..'
    },
    errorMessages: '',
    menu: {
      menuCategory: 'HOME',
      menuType: 'TYPE_BOARD'
    },
    boards: [],
    pages: [],
    endPoint:process.env.VUE_APP_ATTACH_FILE_SERVER_URL,
    dropzoneOptions: {
      url: `${process.env.VUE_APP_BASE_API}/menu/upload/image`,
      thumbnailWidth: 550,
      maxFilesize: 0.5,
      maxFiles:2,
      acceptedFiles: "image/*",
      uploadMultiple: false,
      clickable: true,
      addRemoveLinks: true
    },
    successFile:''
  }),
  watch: {
    item: function (newVal) {
      this.$refs.menuImageDropzone?.removeAllFiles()
      this.$refs.formMenu.resetValidation();
      // console.log(newVal);
      this.menu = _.cloneDeep(newVal ?? {menuType: 'TYPE_BOARD', menuCategory: 'HOME'});

      // console.log(this.menu);
    },
  },
  methods: {
    imageUploadSuccess(file, response) {
      // vdropzone-success -> vdropzone-complete

      const rejectedFiles = this.$refs.menuImageDropzone.getRejectedFiles()
      for (const f of rejectedFiles) {
          this.$refs.menuImageDropzone.removeFile(f);
      }

      const acceptedFiles = this.$refs.menuImageDropzone.getAcceptedFiles()
      for (const f of acceptedFiles) {
        if(f !== file)
          this.$refs.menuImageDropzone.removeFile(f);
      }

      this.menu.menuImage = response.saveName;
    },
    imageUploadCompleteSuccess(response) {

      if(!response.accepted) {
        const acceptedFiles = this.$refs.menuImageDropzone.getAcceptedFiles()
        const rejectedFiles = this.$refs.menuImageDropzone.getRejectedFiles()
        const allFile = [...acceptedFiles, ...rejectedFiles]
        for (const f of allFile) {
          if(f !== response) {
            this.$refs.menuImageDropzone.removeFile(f); // callback -> imageRemove
          }
        }
      }

      // console.log(this.menu.menuImage);
    },
    imageRemove() {
      this.menu.menuImage = null;
    },
    async saveMenu() {
      if (!await this.$refs.formMenu.validate())
        return;

      if(!this.menu.parentId && !this.isModify)
        this.menu.parentId = this.parent?.menuId;

      let c = await menuApi.save(this.menu);

      console.log(c);
      this.menu = c;
      this.menu.childMenus = [];
      // this.isModify = false;
      alert('저장되었습니다.')
      this.$emit('callback-saved', c);
    },
    async editMenu() {
      if (!await this.$refs.formMenu.validate())
        return;

      if (!this.menu.parent_code || this.menu.parent_code === '') {
        this.menu.parent_code = null;
      }
      let editedMenu = await menuApi.editMenu(this.menu);

      // this.treeItem.data.icon = editedMenu.flag_active === 'Y' ? "fa fa-check-circle" : "fa fa-ban";

      // this.isModify = false;
      alert('저장되었습니다.')
      this.$emit('callback-updated', editedMenu)

    },
    resetMenu() {
      if (!this.isModify) {
        this.menu = {};
      } else {
        this.menu = _.cloneDeep(this.item);
      }
      this.$refs.formMenu.resetValidation();

      this.$emit('callback-cancel');

      // this.menu = {};
      // this.chart = {};
    },
    deleteMenu() {
      if (this.menu.childMenus?.length ?? 0 !== 0) {
        alert("하위 메뉴가 존재합니다.");
        return false;
      }
      if (confirm("해당 메뉴를 삭제하시겠습니까?")) {
        menuApi.deleteMenu(this.menu.menuId).then(() => {
          this.$refs.formMenu.resetValidation();
          this.$emit('callback-deleted');
          this.menu = {};
        });
      }
    },
  },
  created() {
    boardApi.list({page: 1, size: -1}).then(data => {
      this.boards = data.content.filter(b => b.activated);
      // console.log(data);
    });
    pageApi.list({page: 1, size: -1}).then(data => {
      this.pages = data.content.filter(p => p.activated);
    });
    console.log(this.$vuetify.icons)
  }

}
</script>

<style lang="scss" scoped>
@import 'src/assets/style/layout/variables';

.dashWrap {
  display: flex;
}

.dashRow {
  display: flex;
  flex-direction: column;
  flex: 0 0 29% 69%;

  &:first-child {
    margin-right: 2%;
  }
}

.tit {
  margin-top: 30px;
  margin-left: 5px;
  margin-bottom: 10px;
  font-size: 18px;
}

.dashBx {
  padding: 20px;
  border: 1px solid #e9e9e9;

  .state {
    padding-top: 37px;
    padding-bottom: 37px;
    cursor: pointer;
    color: #666;

    dt {
      display: flex;
      justify-content: center;
      align-items: baseline;
      margin-bottom: 20px;

      em {
        margin-right: 5px;
        font-size: 50px;
        font-weight: bold;
        color: #333;
      }
    }

    dd {
      font-weight: 500;
    }
  }

  .deposit {
    display: flex;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      flex: 0 0 38%;

      &:nth-child(3) {
        flex: 0 0 24%;
      }

      .depositTit {
        width: 100px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-radius: 25px;
        background: #f6f6f6;
        font-size: 13px;
        font-weight: 600;
        color: #555;
        text-align: center;
      }

      .depositNum {
        display: flex;
        padding-top: 50px;
        padding-right: 30px;

        p {
          margin-right: 50px;

          em {
            font-size: 40px;
            font-weight: bold;
          }
        }
      }
    }
  }

}

.h3Title {
  @include h3-title;
}

.tabContent {
  .formInfo {
    @include form-info;
  }

  .formInfoArea {
    &.align-normal {
      align-items: normal !important;
    }
  ;
  }

  .list {
    display: flex;
    width: 100% !important;

    img {
      width: 100%;
      height: auto;
    }
  }

  .wh300 {
    width: 300px;
    padding: 0;
  }
}
</style>